module.exports = __webpack_public_path__ + "img/compass.00c51732.svg";